module.exports = __webpack_public_path__ + "img/first.a67576d6.png";